import { useEffect, useState } from 'react';

import { fetchSchoolYears } from '../api/school-year';
import { ISchoolYear } from '../types/school-year.type';

interface IDataPromise {
  key: 'years';
  promise: Promise<ISchoolYear[]>;
}

export const useFetchPreInscriptionSchoolFiltersData = () => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [schoolYears, setSchoolYears] = useState<ISchoolYear[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const promises: IDataPromise[] = [{ key: 'years', promise: fetchSchoolYears() }];

      const items = await Promise.allSettled(promises.map(({ promise }) => promise));

      items.forEach((item, idx) => {
        const data = item.status === 'fulfilled' ? item.value : [];
        const { key } = promises[idx];

        switch (key) {
          case 'years':
            setSchoolYears(data as ISchoolYear[]);

            break;

          default:
            break;
        }
      });
    };

    fetchData().finally(() => setLoading(false));
  }, []);

  return {
    schoolYears,
    isLoading,
  };
};
